import { render, staticRenderFns } from "./InfographicItem.vue?vue&type=template&id=5b8ec524&"
import script from "./InfographicItem.vue?vue&type=script&lang=js&"
export * from "./InfographicItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports